import { render, staticRenderFns } from "./WorkCardItem.vue?vue&type=template&id=38f7bab8&scoped=true&"
import script from "./WorkCardItem.vue?vue&type=script&lang=js&"
export * from "./WorkCardItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkCardItem.vue?vue&type=style&index=0&id=38f7bab8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f7bab8",
  null
  
)

export default component.exports